import type { GlobalSearchResultItem, SearchItemTypeKey } from 'models';
import { can } from 'old/utils/permissions';
import { routes } from 'routes/routes';

/**
 * @deprecated Port from JS to TSX, dont inpire by this, needs refactoring
 */
const ASSET_URL_SEGMENT: Partial<Record<SearchItemTypeKey, string>> = {
  activities: 'activities',
  communities: 'communities',
  events: 'events',
  givings: 'givings',
  organizations: 'organizations',
  polls: 'polls',
  posts: 'posts',
  users: 'members',
};

/**
 * @deprecated Port from JS to TSX, dont inpire by this, needs refactoring
 */
export const convertAssetableType = (assetableType: string): SearchItemTypeKey => {
  switch (assetableType) {
    case 'Activity':
      return 'activities';
    case 'Asset':
    case 'AssetFile':
      return 'files';
    case 'Community':
      return 'communities';
    case 'Event':
      return 'events';
    case 'Giving':
      return 'givings';
    case 'Organization':
      return 'organizations';
    case 'Poll':
      return 'polls';
    case 'Post':
      return 'posts';
    case 'Program':
      return 'programs';
    case 'User':
      return 'users';
    default:
      throw new Error(`Unknown assetable type: ${assetableType}`);
  }
};

/**
 * @deprecated Port from JS to TSX, dont inpire by this, needs refactoring
 */
export const getSearchResultPath = (type: SearchItemTypeKey, item: GlobalSearchResultItem): string => {
  switch (type) {
    case 'activities':
      return routes.contentObjects.activities(item.id);
    case 'communities':
      return routes.community.feed(item.id);
    case 'events':
      return routes.events.detail(item.id);
    case 'files': {
      const assetableType = item.assetableType ?? '';
      const assetableId = item.assetableId ?? '';

      if (assetableType === 'Program') {
        return routes.program.assets(assetableId);
      }

      const assetableSearchItemType = convertAssetableType(assetableType);
      const urlSegment = ASSET_URL_SEGMENT[assetableSearchItemType];
      return `/${urlSegment}/${assetableId}/assets`;
    }
    case 'givings':
      return routes.giving.detail(item.id);
    case 'organizations':
      return routes.organization.detail(item.id);
    case 'polls':
      return routes.contentObjects.polls(item.id);
    case 'posts':
      return routes.contentObjects.posts(item.id);
    case 'programs':
      return can(item, 'Program', 'isMemberOfProgram')
        ? routes.program.timeline(item.id)
        : routes.program.about(item.id);
    case 'users':
      return routes.members.detail(item.id);
  }
};

export { type SearchItemTypeKey } from 'models';
